import { createTheme } from "@material-ui/core/styles";

export const colors = {
    primary: '#AFBD36',
    primary700: '#7C8626',
    secondary: '#2d60f5',
    grey: '#505050',
    black: '#000000',
};

const theme = createTheme({
    props: {
        MuiButtonBase: {
            disableRipple: true
        }
    },
    typography: {
        fontFamily: `Nunito Sans, sans-serif`,
        fontSize: 18,
        letterSpacing: 'normal',
    },
    palette: {
        primary: {
            main: colors.primary,
        },
        secondary: {
            main: colors.secondary,
        },
        background: {
            default: 'transparent'
        },
        text: {
            primary: colors.black,
        }
    },
    link: {
        textDecorationStyle: 'none'
    }
});

theme.overrides = {
    MuiPaper: {
        root: {
            backgroundColor: 'transparent',
            minHeight: 520,
            paddingTop: 4,
        },
        elevation1: {
            boxShadow: 'none'
        }
    },
    MuiLink: {
        root: {
            color: colors.black,
        },
        underlineHover: {
            textDecoration: 'underline',
            '&:hover': {
                color: colors.primary700,
            }
        }
    },
    MuiButton: {
        contained: {
            fontWeight: 700,
            position: 'relative',
            backgroundColor: colors.primary,
            color: colors.black,
            lineHeight: 1.5,
            borderRadius: 8,
            boxShadow: 'none',
            padding: '12px 16px',
            border: `none`,
            zIndex: 0,
            overflow: 'hidden',
            transition: 'all .3s',
            textTransform: 'none',
            '&:hover': {
                backgroundColor: '#4A4F17',
                boxShadow: 'none',
                color: 'white'
            },
        }
    },
    MuiInput: {
        underline: {
            '&:before': {
                borderBottomColor: colors.grey,
            },
            '&:after': {
                borderBottomColor: colors.grey,
            },
            '&:hover:not($disabled):before': {
                borderBottomColor: colors.primary,
            },
        },
        root: {
            fontSize: theme.typography.fontSize
        }
    },
    MuiInputLabel: {
        animated: {
            fontSize: theme.typography.fontSize
        }
    },
    MuiTableCell: {
        head: {
            fontSize: 16,
            fontWeight: 500,
            paddingBottom: 0,
            borderBottom: `2px solid ${colors.primary}`,
        },
        root: {
            padding: 13,
            height: 50,
            [theme.breakpoints.up('sm')]: {
                borderBottom: `1px solid ${colors.primary}`,
            },
            [theme.breakpoints.down('xs')]: {
                border: 0,
            }
        }
    },
    MuiTableHead: {
      root: {
          [theme.breakpoints.down('xs')]: {
              display: 'none',
          }
      }
    },
    MuiTableBody: {
        root: {
            '& > tr':  {
                '& > td:nth-child(1)': {
                    minWidth: 100,
                    fontWeight: 600,
                },
                '& > td:nth-child(2)': {
                    fontSize: theme.typography.fontSize,
                },
                [theme.breakpoints.up('sm')]: {
                    '& > td:nth-child(1)': {
                        width: 200,
                    },
                    '& > td:nth-child(3)': {
                        width: 140
                    },
                    '& > td:nth-child(4)': {
                        width: 180
                    },
                },
                [theme.breakpoints.down('xs')]: {
                    display: 'block',
                    borderBottom: `1px solid ${colors.primary}`,
                    '&:first-of-type': {
                        borderTop: `1px solid ${colors.primary}`,
                    },
                    '& > td': {
                        display: 'block',
                        width: 'auto',
                        height: 'auto',
                        '&:not(:first-child)': {
                            paddingTop: 0,
                        }
                    },
                    '& > td:nth-child(3)': {
                        display: 'none',
                    },
                },
            }
        }
    },
    MuiMenuItem: {
        root: {
            fontSize: theme.typography.fontSize
        }
    },
    MuiPopover: {
        paper: {
            backgroundColor: '#fff',
            [theme.breakpoints.down('xs')]: {
                minWidth: 'auto !important',
                '& > ul': {
                    '& > li': {
                        whiteSpace: 'initial',
                    }
                },
            }
        },
    },
    MuiLinearProgress: {
        root: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
        }
    }
};

export default theme;
